// src/pages/Dashboard/Admin/DetailsAdherents/components/EmptyAdherentState.jsx

import React from "react";
import { FaIdCard } from "react-icons/fa";

export default function EmptyAdherentState({ loading }) {
  return (
    <div className="rounded-[28px] border border-dashed border-slate-300 bg-slate-50 px-6 py-14 text-center dark:border-slate-700 dark:bg-slate-900/50">
      {loading ? (
        <div className="mx-auto h-24 max-w-xl animate-pulse rounded-[28px] bg-slate-200 dark:bg-slate-800" />
      ) : (
        <>
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-gradient-to-br from-blue-500 via-violet-500 to-pink-500 text-white shadow-lg">
            <FaIdCard className="text-2xl" />
          </div>

          <h3 className="mt-5 text-lg font-semibold text-slate-900 dark:text-white">
            Aucun adhérent sélectionné
          </h3>

          <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
            Utilisez les filtres puis sélectionnez un adhérent pour afficher sa
            fiche dashboard complète.
          </p>
        </>
      )}
    </div>
  );
}